// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".BlogArticleContent strong {\n  font-family: \"Gotham-Medium\";\n  font-weight: 900; }\n\n@media all and (max-width: 750px) {\n  .BlogArticleContent {\n    margin: 0 2rem; } }\n\n@media all and (max-width: 520px) {\n  .BlogArticleContent {\n    margin: 0 1rem; } }\n", ""]);
// Exports
module.exports = exports;
